import { useEffect } from "react";
import logo from './showcase.png';
import appStore from './app_store.png';
import googlePlay from './google_play.png';
import './App.css';

function Download() {

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    if (isAndroid) {
      window.location.href = "https://play.google.com/store/apps/details?id=com.hang10.android";
    } else if (isIOS) {
      window.location.href = "https://apps.apple.com/us/app/id6748242464";
    }
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <div className="Content">
          <div className="Left">
            <img src={logo} alt="logo" className="Logo" />
          </div>
          <div className="Right">
            <div className="Store-badges">
              <a href="https://apps.apple.com/us/app/id6748242464" target="_blank" rel="noopener noreferrer">
                <img src={appStore} alt="App Store" className="Store-icon" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.hang10.android" target="_blank" rel="noopener noreferrer">
                <img src={googlePlay} alt="Google Play" className="Store-icon" />
              </a>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default Download;